// extracted by mini-css-extract-plugin
export default {"buttonGroup":"Form_buttonGroup__rD4sw","legend":"Form_legend__52-jd","fieldset":"Form_fieldset__sOqIs"};